<template>
    <b-modal id="create-office-transfers-modal" title="Request Office Transfer" hide-footer>
        <loading-screen :is-loading="isSaving"></loading-screen>

        <div v-if="isLoading" class="text-center">
            <b-spinner class="m-2" variant="itg-dark" role="status"></b-spinner>
        </div>

        <div v-if="!isLoading && allOffices.length === 0" class="alert alert-danger">
            No offices to transfer to
        </div>

        <div v-if="!isLoading && allOffices.length">

            <div class="form-group">
                <div class="block mb-3">
                    <label for="new-office-id">Which office would you like to transfer this ticket to?</label>
                </div>

                <div class="mb-2 form-check" v-for="(office, i) in allOffices" :key="`office-${i}`">
                    <label class="form-check-label">
                        <input id="checkbox" class="form-check-input" name="name" type="checkbox" :value="office.id"
                            v-model="newOfficeIds" />
                        <div style="padding-top: 2px;">{{ office.name }}</div>
                    </label>
                </div>

                <div class="pt-4">
                    <button class="btn btn-itg-dark mb-0" :disabled="newOfficeIds.length == 0" @click="requestOfficeTransfer">
                        Request Office Transfer
                    </button>
                </div>

            </div>

        </div>

    </b-modal>
</template>

<script>
import Forms from "../../../../../mixins/Forms";
import LoadingScreen from '../../../../../components/LoadingScreen.vue';
import axios from "axios";

export default {
    name: "CreateOfficeTransferModal",
    props: ['ticketId'],
    components: { LoadingScreen },
    data() {
        return {
            newOfficeIds: [],
            isSaving: false,

            isLoadingAllOffices: false,
            allOffices: []
        }
    },
    mixins: [Forms],
    created() {
        this.loadAllOffices();
    },
    computed: {
        isLoading() {
            return this.isLoadingAllOffices;    
        }
    },
    methods: {
        loadAllOffices() {
            let vm = this;
            vm.isLoadingAllOffices = true;

            axios.get(window.API_BASE + '/offices').then(r => {
                vm.allOffices = r.data;
                vm.isLoadingAllOffices = false;
            }).catch(e => {
                vm.isLoadingAllOffices = false;
                console.log(e);
                this.$notify.error({ title: "Error", message: "Error loading all offices" });
            });
        },

        requestOfficeTransfer() {
            let vm = this;

            if (vm.newOfficeIds.length == 0) {
                vm.$notify.error({ title: "Error", message: "Please select at least one office" });
                return;
            }

            vm.isSaving = true;

            axios.post(window.API_BASE + '/tickets/' + vm.ticketId + '/office-transfers/multiple', {
                office_ids: vm.newOfficeIds
            }).then(r => {
                vm.isSaving = false;
                vm.$emit('office-transfer-requested', r.data);
                vm.newOfficeIds = [];
                vm.$bvModal.hide('create-office-transfers-modal');
            }).catch(e => {
                vm.isSaving = false;
                console.log(e);
                let errors = vm.getErrorsAsArray(e);
                let error = errors.length ? errors[0] : "Error requesting office transfer";
                vm.$notify.error({ title: "Error", message: error });
            });
        }
    }
}
</script>

<style></style>